jQuery(() => {
  addToCartObj.bindElementHandlers()
})
function doExtensionChange(tmpItemID: string): void {
  let groundShipIDs: Array<string>,
    InstockOverride: boolean,
    stockMessage: string,
    price: number,
    listPrice: number,
    addOnPrice: number,
    addOnListPrice: number,
    Instock: boolean,
    points: number,
    listPoints: number,
    addOnPoints: number,
    addOnListPoints: number
  const addOnProductID =
    document.getElementById('addOnProductID') !== null
      ? (<HTMLInputElement>document.getElementById('addOnProductID')).value
      : ''
  const productIDs = (<HTMLFormElement>document.getElementById('OCForm1'))
    .productID
  let elementIndex: number,
    addOnElementIndex = 0
  let tmpInvtID = ''
  if (productIDs.length !== undefined) {
    for (let i = 0; i < productIDs.length; i++) {
      if (productIDs[i].value === tmpItemID) {
        elementIndex = i
      }
      if (productIDs[i].value === addOnProductID) {
        addOnElementIndex = i
      }
    }
    groundShipIDs = (<HTMLFormElement>(
      document.getElementById('OCForm1')
    )).groundShipIDs.value.split(',')
    InstockOverride = false
    Instock = false
    if (groundShipIDs !== null) {
      for (let j = 0; j < groundShipIDs.length; j++) {
        if (groundShipIDs[j] === tmpItemID) {
          InstockOverride = true
        }
        if (groundShipIDs[j] === addOnProductID) {
          Instock = true
        }
      }
    }
    stockMessage = productObj.doGetStockMessage(
      tmpItemID,
      elementIndex,
      InstockOverride
    )
    if (stockMessage !== '') {
      try {
        document.getElementById(`SPANstock${elementIndex}`).innerHTML =
          stockMessage
      } catch (e) {}
    }
    tmpInvtID = productObj.getProductID(tmpItemID, elementIndex)
    price = productObj.getPrice(tmpInvtID)
    listPrice = productObj.getPrice(tmpInvtID, 'listprice')
    points = productObj.getPrice(tmpInvtID, 'points')
    listPoints = productObj.getPrice(tmpInvtID, 'listpoints')
    if (
      Number.parseFloat(price.toString()) >
      Number.parseFloat(listPrice.toString())
    ) {
      document.getElementById(`currentPrice${elementIndex}`).innerHTML =
        `<span class="salePrice">${CommonUtils.toUSD(price)}</span>`
    } else {
      if (price !== 0 && listPrice !== 0 && price !== listPrice) {
        document.getElementById(`currentPrice${elementIndex}`).innerHTML =
          `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${CommonUtils.toUSD(listPrice)}</strike><span aria-hidden="false" class="only-readers">Sale price</span><span class="salePrice">${CommonUtils.toUSD(price)}</span>`
      } else {
        if (price !== 0) {
          document.getElementById(`currentPrice${elementIndex}`).innerHTML =
            CommonUtils.toUSD(price)
        } else {
          document.getElementById(`currentPrice${elementIndex}`).innerHTML =
            'Select an Option'
        }
      }
      if (points !== 0 && listPoints !== 0 && points !== listPoints) {
        document.getElementById(`currentPoints${elementIndex}`).innerHTML =
          `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${CommonUtils.formatPoints(listPoints)} Points</strike><span aria-hidden="false" class="only-readers">Sale price</span><span class="salePrice">${CommonUtils.formatPoints(points)} Points</span>`
      } else {
        if (points !== 0) {
          document.getElementById(`currentPoints${elementIndex}`).innerHTML =
            `${CommonUtils.formatPoints(points)} Points`
        } else {
          document.getElementById(`currentPoints${elementIndex}`).innerHTML =
            'Select an Option'
        }
      }
    }
    classOptions.itemProps[tmpItemID].listPrice = listPrice
    classOptions.itemProps[tmpItemID].price = price
    if (addOnProductID !== null) {
      productObj.checkAddOnStock(
        tmpItemID,
        elementIndex,
        addOnProductID,
        addOnElementIndex,
        Instock
      )
      tmpInvtID = productObj.getProductID(addOnProductID, addOnElementIndex)
      addOnPrice = productObj.getPrice(tmpInvtID)
      addOnListPrice = productObj.getPrice(tmpInvtID, 'listprice')
      addOnPoints = productObj.getPrice(tmpInvtID, 'points')
      addOnListPoints = productObj.getPrice(tmpInvtID, 'listpoints')
      if (
        Number.parseFloat(addOnPrice.toString()) >
        Number.parseFloat(addOnListPrice.toString())
      ) {
        document.getElementById('addOnPrice').innerHTML =
          CommonUtils.toUSD(addOnPrice)
      } else {
        if (
          addOnPrice !== 0 &&
          addOnListPrice !== 0 &&
          addOnPrice !== addOnListPrice
        ) {
          document.getElementById('addOnPrice').innerHTML =
            `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${CommonUtils.toUSD(addOnListPrice)}</strike> <span aria-hidden="false" class="only-readers">Sale price</span>${CommonUtils.toUSD(addOnPrice)}`
        } else {
          if (addOnPrice !== 0) {
            document.getElementById('addOnPrice').innerHTML =
              CommonUtils.toUSD(addOnPrice)
          } else {
            try {
              document.getElementById('addOnPrice').innerHTML = (<
                HTMLInputElement
              >document.getElementById('addOnpriceRange')).value
            } catch (e) {}
          }
        }
        if (
          addOnPoints !== 0 &&
          addOnListPoints !== 0 &&
          addOnPoints !== addOnListPoints
        ) {
          document.getElementById('addOnPoints').innerHTML =
            `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${CommonUtils.formatPoints(addOnListPoints)} Points</strike> <span aria-hidden="false" class="only-readers">Sale price</span>${CommonUtils.formatPoints(addOnPoints)} Points`
        } else {
          if (addOnPoints !== 0) {
            document.getElementById('addOnPoints').innerHTML =
              `${CommonUtils.formatPoints(addOnPoints)} Points`
          } else {
            try {
              document.getElementById('addOnPoints').innerHTML = (<
                HTMLInputElement
              >document.getElementById('addOnpointsRange')).value
            } catch (e) {}
          }
        }
      }
      classOptions.itemProps[tmpItemID].addOn.listPrice = addOnListPrice
      classOptions.itemProps[tmpItemID].addOn.price = addOnPrice
    }
  } else {
    groundShipIDs = (<HTMLFormElement>(
      document.getElementById('OCForm1')
    )).groundShipIDs.value.split(',')
    InstockOverride = false
    if (groundShipIDs !== null) {
      for (let j = 0; j < groundShipIDs.length; j++) {
        if (groundShipIDs[j] === tmpItemID) {
          InstockOverride = true
          j = groundShipIDs.length
        }
      }
    }
    stockMessage = productObj.doGetStockMessage(tmpItemID, 0, InstockOverride)
    if (stockMessage !== '') {
      try {
        document.getElementById('SPANstock0').innerHTML = stockMessage
      } catch (e) {}
    }
    tmpInvtID = productObj.getProductID(tmpItemID, 0)
    price = productObj.getPrice(tmpInvtID)
    listPrice = productObj.getPrice(tmpInvtID, 'listprice')
    points = productObj.getPrice(tmpInvtID, 'points')
    listPoints = productObj.getPrice(tmpInvtID, 'listpoints')
    if (
      Number.parseFloat(price.toString()) >
      Number.parseFloat(listPrice.toString())
    ) {
      document.getElementById('currentPrice0').innerHTML =
        `<span class="salePrice">${CommonUtils.toUSD(price)}</span>`
    } else {
      if (price !== 0 && listPrice !== 0 && price !== listPrice) {
        document.getElementById('currentPrice0').innerHTML =
          `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${CommonUtils.toUSD(listPrice)}</strike><span aria-hidden="false" class="only-readers">Sale price</span><span class="salePrice">${CommonUtils.toUSD(price)}</span>`
      } else {
        if (price !== 0) {
          document.getElementById('currentPrice0').innerHTML =
            CommonUtils.toUSD(price)
        } else {
          document.getElementById('currentPrice0').innerHTML =
            'Select an Option'
        }
      }
      if (points !== 0 && listPoints !== 0 && points !== listPoints) {
        document.getElementById('currentPoints0').innerHTML =
          `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${CommonUtils.formatPoints(listPoints)} Points</strike><span aria-hidden="false" class="only-readers">Sale price</span><span class="salePrice">${CommonUtils.formatPoints(points)} Points</span>`
      } else {
        if (points !== 0) {
          document.getElementById('currentPoints0').innerHTML =
            `${CommonUtils.formatPoints(points)} Points`
        } else {
          document.getElementById('currentPoints0').innerHTML =
            'Select an Option'
        }
      }
    }
    classOptions.itemProps[tmpItemID].listPrice = listPrice
    classOptions.itemProps[tmpItemID].price = price
  }
}
